// affiliate-tracking.js
//
// Captures ?ref=<code> from the URL on landing, stores it in a 30-day cookie,
// and writes it to the Shopify cart as the `affiliate_code` attribute.
// Shopify automatically promotes cart attributes to order.note_attributes at
// checkout, where the Bureau Plus ERP connector reads it.
//
// Attribution model: last-touch (a new ?ref overwrites the cookie).
// Spec: docs/biorelax-spec.md:441-454
// Operational doc: docs/affiliate-tracking.md

(function () {
  'use strict';

  var COOKIE_NAME = 'biorelax_affiliate_code';
  var COOKIE_DAYS = 30;
  var ATTRIBUTE_KEY = 'affiliate_code';
  var REF_PARAM = 'ref';
  var VALID_REF = /^[A-Za-z0-9_\-]{1,64}$/;

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]+)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie =
      name + '=' + encodeURIComponent(value) +
      '; expires=' + d.toUTCString() +
      '; path=/; SameSite=Lax';
  }

  function readRefFromUrl() {
    try {
      var ref = new URLSearchParams(window.location.search).get(REF_PARAM);
      if (!ref || !VALID_REF.test(ref)) return null;
      return ref;
    } catch (e) {
      return null;
    }
  }

  function syncCartAttribute(code) {
    var body = { attributes: {} };
    body.attributes[ATTRIBUTE_KEY] = code;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
    }).catch(function (err) {
      if (window.console && console.warn) {
        console.warn('[affiliate-tracking] cart update failed:', err);
      }
    });
  }

  var fromUrl = readRefFromUrl();
  if (fromUrl) {
    setCookie(COOKIE_NAME, fromUrl, COOKIE_DAYS);
  }

  var code = getCookie(COOKIE_NAME);
  if (code) {
    syncCartAttribute(code);
  }
})();
